/*
 * Routes.ts
 * Description: Includes the declaration of the
 * other routesOther for Vue Router
 */

// Importing RouteConfing interface
import { RouteConfig } from 'vue-router';
// Importing routes
import routesAddresses from '@/config/routes/routes-addresses';
import routesAuth from '@/config/routes/routes-auth';
import routesCategories from '@/config/routes/routes-categories';
import routesGeneral from '@/config/routes/routes-general';
import routesOrders from '@/config/routes/routes-orders';
import routesOther from '@/config/routes/routes-other';
import routesProducts from '@/config/routes/routes-products';
import routesRestaurants from '@/config/routes/routes-restaurants';
import routesStaff from '@/config/routes/routes-staff';
import routesUsers from '@/config/routes/routes-users';
import routesDiscount from '@/config/routes/routes-discounts';
import routesCoupon from '@/config/routes/routes-coupons';

// Declaring list of routes
const routes = [
    ...routesAddresses,
    ...routesAuth,
    ...routesUsers,
    ...routesOther,
    ...routesOrders,
    ...routesGeneral,
    ...routesRestaurants,
    ...routesStaff,
    ...routesCategories,
    ...routesProducts,
    ...routesDiscount,
    ...routesCoupon,
] as RouteConfig[];

export default routes;
